import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useNotification } from '../../context/NotificationContext';
import './Header.scss';

const Header: React.FC = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState<boolean>(false);
  const [openMenus, setOpenMenus] = useState<{ [key: string]: boolean }>({});
  const { currentMessage } = useNotification();

  const toggleMobileMenu = (): void => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
    if (!isMobileMenuOpen) {
      setOpenMenus({});
    }
  };

  const toggleMenu = (e: React.MouseEvent, key: string): void => {
    e.preventDefault();
    const current = !!openMenus[key];
    setOpenMenus({ [key]: !current });
  };

  const closeMobileMenu = (): void => {
    setIsMobileMenuOpen(false);
    setOpenMenus({});
  };

  const onNavClick = (): void => {
    closeMobileMenu();
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);
  };

  return (
    <header className={`app-header ${currentMessage && currentMessage.trim() !== '' ? 'with-notification' : ''}`}>
      <div className="container">
        <h1>Florida First Psychiatry</h1>
        <button 
          className={`mobile-menu-toggle ${isMobileMenuOpen ? 'active' : ''}`}
          onClick={toggleMobileMenu}
          aria-label="Toggle mobile menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
        <nav className={`nav-menu ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
          <ul>
            <li><Link to="/" onClick={onNavClick}>Home</Link></li>
            <li className="dropdown">
              <a href="#" onClick={(e) => toggleMenu(e, 'about')}>About</a>
              <ul className={`dropdown-menu ${openMenus['about'] ? 'show' : ''}`}>
                <li><Link to="/about-overview" onClick={onNavClick}>Overview</Link></li>
                <li><Link to="/about-providers" onClick={onNavClick}>Providers</Link></li>
              </ul>
            </li>
            <li className="dropdown">
              <Link to="/services" onClick={onNavClick}>Services</Link>
            </li>
            <li className="dropdown">
              <a href="#" onClick={(e) => toggleMenu(e, 'patient')}>Patient</a>
              <ul className={`dropdown-menu ${openMenus['patient'] ? 'show' : ''}`}>
                <li><Link to="/patient-forms" onClick={onNavClick}>Patient Forms</Link></li>
                <li><Link to="/insurance-info" onClick={onNavClick}>Insurance Info</Link></li>
                <li><Link to="/new-patient" onClick={onNavClick}>New Patient</Link></li>
                <li><Link to="/patient-education" onClick={onNavClick}>Patient Education</Link></li>
              </ul>
            </li>
            <li className="dropdown">
              <a href="#" onClick={(e) => toggleMenu(e, 'login')}>Sign In</a>
              <ul className={`dropdown-menu ${openMenus['login'] ? 'show' : ''}`}>
                <li>
                  <a 
                    href="https://patientportal.advancedmd.com/account/logon?lk=142885" 
                    target="_blank" 
                    rel="noopener"
                    onClick={onNavClick}
                  >
                    Patient Sign In
                  </a>
                </li>
                <li><a href="#" onClick={onNavClick}>Provider Sign In</a></li>
              </ul>
            </li>
            <li><Link to="/contact" onClick={onNavClick}>Contact</Link></li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;

